import axios from "axios";
import { history } from "../utils/history";
import { customDispatch } from "../utils/customDispatch";
import { reset } from "../store";
import {
  getContentType,
} from "./helper";

import {
  BASE_URL,
  AUTH_TOKEN_KEY,
} from "./constants";
import {showError} from "./notification";

export const NETWORK_ERROR_MESSAGE =
  "A server/network error occurred. Looks like CORS might be the problem. Sorry about this - we will get it fixed shortly.";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (config?.url?.includes('punchIn') || config?.url?.includes('punchOut')) {
      config.headers["Content-Type"] = 'multipart/form-data';
    } else if (config?.url) {
      const contentType = getContentType(config?.url);
      config.headers["Content-Type"] = contentType;
    }

    // Add auth token to all requests
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const handleResponseError = async (err) => {
  if (typeof err.response === "undefined") {
    showError(NETWORK_ERROR_MESSAGE);
    return Promise.reject(err);
  }

  if (err.response.status === 401) {
    localStorage.clear(); // clear local storage
    customDispatch.dispatch(reset()); // reset store
    history.navigate("/", {replace: true});
    return Promise.reject(err);
  }

  return Promise.reject(err.response?.data);
};

axiosInstance.interceptors.response.use(
  (res) => {
    // Reset the session expiration flag if the response is successful
    return res;
  },
  handleResponseError
);

export default axiosInstance;
